import React from 'react';
import { Box, Text, TextInput } from '@mantine/core';

interface PageNumbersSectionProps {
    fileKind: string;
    pageNumbersInput: string;
    pageNumbersError: string;
    isDebouncing: boolean;
    countdown: number;
    onPageNumbersChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PageNumbersSection: React.FC<PageNumbersSectionProps> = ({
    fileKind,
    pageNumbersInput,
    pageNumbersError,
    isDebouncing,
    countdown,
    onPageNumbersChange,
}) => (
    <Box className="option-section">
        <Text size="sm" fw={600} className="section-title">
            Page Numbers
        </Text>
        <TextInput
            size="sm"
            placeholder={
                fileKind === 'image'
                    ? 'Image detected: fixed to 1'
                    : 'e.g., 1, 3-5, 6, 73'
            }
            value={pageNumbersInput}
            onChange={onPageNumbersChange}
            error={pageNumbersError || undefined}
            description={
                !pageNumbersError
                    ? fileKind === 'image'
                        ? 'Single page (1) - image file'
                        : isDebouncing
                            ? `Applying in ${countdown || 3}s…`
                            : 'Leave empty to process all pages'
                    : undefined
            }
            disabled={fileKind === 'image'}
        />
    </Box>
);

export default PageNumbersSection;
